export const formatNumber = (value: number, decimalsLength = 0): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: decimalsLength,
    minimumFractionDigits: decimalsLength
  }).format(value);
};

export const isNumber = (str: string): boolean => {
  return !isNaN(Number(str));
};

export const numberFormatter = (value: number, options?: Intl.NumberFormatOptions): string => {
  return new Intl.NumberFormat("en-US", options).format(value);
};
